module.exports = __webpack_public_path__ + "img/filter.849c9645.svg";